import React from 'react'
import { ReactComponent as Close } from './icons/close.svg'
function CloseButton(props) {
  return (
    <button type="button" {...props}>
      <Close />
    </button>
  )
}

export default CloseButton
